import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AsyncPipe, CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule } from './modal/modal.module';
import { NavComponent } from './nav/nav.component';
import { DataService } from './services/data/data.service';
import { AdjustmentService } from './services/data/adjustment.services';
import { ApnUtilitiesService } from './services/data/apn-utilities.service';
import { AuthGuardService } from './services/guards/auth-guard.service';
import { AuthService } from './services/auth-security/auth.service';
import { InvoiceService } from './services/data/invoice.service';
import { LoggingService } from './services/helper/log.service';
import { MessageService } from './services/broadcast/message-service';
import { LotService } from './services/data/lot.service';
import { QuicksearchService } from './services/data/quicksearch.service';
import { UserService } from './services/auth-security/user.service';
import { UtilitiesService } from './services/helper/utilities.service';
import { ValidationService } from './services/auth-security/validation.services';
// import { CookieService } from 'ngx-cookie-service';
import { QueryMessageService } from './services/broadcast/MessageDispatchingService';

import { DataBroadcastService } from './services/broadcast/data-broadcast.service';
import { ClonerService } from './services/helper/cloner.service';
import { ParkerStateService } from './services/state/parker-state.service';
import { NavProfileComponent } from './nav-profile/nav-profile.component';
import { SharedModule } from '../shared/shared.module';
import { QuickstartStateService } from './services/state/quickstart-state.service';
import { FileService } from './services/file-management/file.service';
import { CompanyStateService } from './services/state/company-state.service';
import { ClipboardModule } from '@angular/cdk/clipboard';

import {
  IgxButtonModule,
  IgxIconModule,
  IgxLayoutModule,
  IgxNavigationDrawerModule,
  IgxRippleModule,
  IgxToggleModule,
  IgxNavbarModule,
  IgxTabsModule,
  IgxGridModule,
  IgxTreeModule,
  IgxSelectModule,
  IgxInputGroupModule,
} from '@infragistics/igniteui-angular';

import {
  IgxLegendModule,
  IgxDataChartCoreModule,
  IgxDataChartCategoryModule,
  IgxDataChartCategoryCoreModule,
  IgxDataChartInteractivityModule,
  IgxDataChartAnnotationModule,
  IgxDataChartStackedModule,
  IgxStackedFragmentSeriesModule,
  IgxCalloutLayerModule,
} from 'igniteui-angular-charts';

import { GenericConfirmationDialogComponent } from './dialog/generic-confirmation-dialog/generic-confirmation-dialog.component';
import { WarningConfirmationDialogComponent } from './dialog/warning-confirmation-dialog/warning-confirmation-dialog.component';
import { ErrorDialogStopComponent } from './dialog/error-dialog-stop/error-dialog-stop.component';
import { DataDomainListService } from './services/data/data-domain-list.service';
import { GeneralDialogOkComponent } from './dialog/general-dialog-ok/general-dialog-ok.component';
import { DialogUploadingComponent } from './dialog/dialog-uploading/dialog-uploading.component';
import { DialogDownloadingComponent } from './dialog/dialog-downloading/dialog-downloading.component';
import { GenericProcessingComponent } from './dialog/generic-processing/generic-processing.component';
import { DataTestService } from './services/data/data-test.service';
import { NavSidebarComponent } from './nav-sidebar/nav-sidebar.component';
import { LotSelectComponent } from './dialog/lots/lot-select/lot-select.component';
import { ConfirmTransferPaymentComponent } from './dialog/dialog-confirm-transfer-payment/confirm-transfer-payment.component';
import { MessageDialogService } from './services/helper/message-dialog.service';
import { GenericRequiredDataComponent } from './dialog/generic-required-data/generic-required-data.component';
import { DialogProcessingModalComponent } from './dialog/dialog-processing-modal/dialog-processing-modal.component';
import { SandboxService } from './services/data/sandbox.service';
import { IssueDataService } from './services/data/issue-data.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ModalModule,
    IgxButtonModule,
    IgxIconModule,
    IgxLayoutModule,
    IgxNavigationDrawerModule,
    IgxRippleModule,
    IgxToggleModule,
    IgxNavbarModule,
    IgxTabsModule,
    IgxGridModule,
    SharedModule,
    ClipboardModule,
    IgxNavigationDrawerModule,
    IgxTreeModule,
    RouterModule,
    IgxSelectModule,
    IgxInputGroupModule,
    AsyncPipe,
    IgxLegendModule,
    IgxDataChartCoreModule,
    IgxDataChartCategoryModule,
    IgxDataChartCategoryCoreModule,
    IgxDataChartInteractivityModule,
    IgxDataChartAnnotationModule,
    IgxDataChartStackedModule,
    IgxStackedFragmentSeriesModule,
    IgxCalloutLayerModule,
    DialogProcessingModalComponent,
  ],
  exports: [
    HttpClientModule,
    ModalModule,
    NavComponent,
    NavSidebarComponent,
    IgxButtonModule,
    IgxIconModule,
    IgxLayoutModule,
    IgxNavigationDrawerModule,
    IgxRippleModule,
    IgxToggleModule,
    IgxNavbarModule,
    IgxTabsModule,
    IgxGridModule,
    ClipboardModule,
    IgxNavigationDrawerModule,
    IgxSelectModule,
    IgxInputGroupModule,
    AsyncPipe,
    IgxLegendModule,
    IgxDataChartCoreModule,
    IgxDataChartCategoryModule,
    IgxDataChartCategoryCoreModule,
    IgxDataChartInteractivityModule,
    IgxDataChartAnnotationModule,
    IgxDataChartStackedModule,
    IgxStackedFragmentSeriesModule,
    IgxCalloutLayerModule,
  ],
  declarations: [
    NavComponent,
    NavProfileComponent,
    GenericConfirmationDialogComponent,
    WarningConfirmationDialogComponent,
    ErrorDialogStopComponent,
    GeneralDialogOkComponent,
    DialogUploadingComponent,
    DialogDownloadingComponent,
    GenericProcessingComponent,
    NavSidebarComponent,
    LotSelectComponent,
    ConfirmTransferPaymentComponent,
    GenericRequiredDataComponent,
  ],
  providers: [
    IssueDataService,
    DataService,
    SandboxService,
    DataDomainListService,
    AdjustmentService,
    ApnUtilitiesService,
    AuthService,
    InvoiceService,
    LoggingService,
    MessageService,
    LotService,
    QuicksearchService,
    UserService,
    UtilitiesService,
    ValidationService,
    // CookieService,
    QueryMessageService,
    DecimalPipe,
    DatePipe,
    DataBroadcastService,
    ClonerService,
    ParkerStateService,
    QuickstartStateService,
    FileService,
    CompanyStateService,
    DataTestService,
    MessageDialogService,
  ],
})
export class CoreModule {
  // Ensure that CoreModule is only loaded into AppModule

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor() {}
}
